module.exports = "/_next/static/images/404-54e349035c2c1f484c3b0c27eb31844a.png";